import { UPDATE_DOCUMENT_BAR } from '../constants';

export default (
  state = {
    documentId: undefined,
    display: false,
    taskIdResourceIds: [],
    tagTypeId: undefined,
    resourceId: undefined,
    filePrefix: undefined,
    fileExtension: undefined,
    tags: [],
    hasNote: false,
    pendingDocument: undefined,
  },
  { type, payload },
) => {
  switch (type) {
    case UPDATE_DOCUMENT_BAR:
      return { ...state, ...payload };
    case 'SET_PENDING_DOCUMENT':
      return { ...state, pendingDocument: payload };
    default:
      return state;
  }
};
